<template>
  <div id="commodities" class="commodities">
    <div v-if="isAdd">
      <CommoditiesEdit ref="CommoditiesEdit" :is-client="true" :active-name="activeName" @save="clickSave" />
    </div>
    <div v-if="isEdit" class="card-one">
      <div class="card-one-l">
        <div class="card-one-l-1">商品信息</div>
        <div class="card-one-l-2">点击选择或添加订单商品</div>
      </div>
      <div class="card-one-r">
        <button class="by-button--primary" @click="add()"><span>+</span>新增商品信息</button>
      </div>
    </div>
    <div v-if="isEdit" class="card-two">
      <template v-for="(item,i) in productList">
        <div
          :key="i"
          :class="['card-two-item', {'card-two-item-active':activeProductList.includes(item.id)}]"
          @click="activeList(item)"
        >
          <div class="img-class">
            <img v-if="item.productImage" :src="item.productImage" width="120px" height="120px">
            <img
              v-if="!item.productImage"
              src="@/assets/img/manage/settings/pic_com_doc.png"
              width="120px"
              height="120px"
            >
            <img
              v-if="activeProductList.includes(item.id)"
              class="active-img"
              src="@/assets/img/client/booking/grouping@2x.png"
              width="24px"
              height="24px"
            >
          </div>
          <div class="card-content">
            <p>{{ item.productName }}</p>
            <div>SKU：{{ item.skuCode }}</div>
            <div>URL：{{ item.url }}</div>
            <div>HS/HTS：{{ item.HSorHTSCode }}</div>
          </div>
          <div class="card-button">
            <span @click="del(item)">删除</span>
            <button class="by-common--primary" @click="edit(item)">修改</button>
          </div>
        </div>
      </template>
      <div class="foot-buttom">
        <!-- <span>What can' t I ship?</span> -->
        <button class="by-button--primary" @click="confirm">确认</button>
      </div>
    </div>
    <div v-if="isClickSave" class="card-third">
      <div v-for="(item,i) in orderProductList" :key="i" class="card-third-item">
        <div class="img-class"><img
          :src="item.productImage?item.productImage:require('@/assets/img/manage/settings/pic_com_doc.png')"
          width="120px"
          height="120px"
        ></div>
        <div class="card-content">
          <p>{{ item.nameEn }}</p>
          <div>SKU：{{ item.skuId }}</div>
          <div>URL：{{ item.saleUrl }}</div>
          <div>HS/HTS：{{ item.customlabel }}</div>
        </div>
      </div>
      <div class="foot-buttom">
        <button class="by-common--primary" @click="showCustomerCommodity">修改商品信息</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCustomerCommodity,
  DeleteCustomerCommodity
} from '../../../../../../../api/user.js'
import {
  SaveOrderCommodities,
  GetOrderCommodities,
  CheckOrderComplete
} from '../../../../../../../api/order.js'
import CommoditiesEdit from './commoditiesEdit.vue'
import define from '@/utils/define'
export default {
  name: 'Commodities',
  components: {
    // 组件的引用
    CommoditiesEdit
  },
  props: {
    // 父辈向子辈传参
    activeName: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      isClickSave: false,
      productList: [],
      activeProductList: [],
      isAdd: true,
      isEdit: false,
      data: {},
      orderProductList: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {},
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      console.log('comm', data)
      this.data = data
      GetOrderCommodities(this.data.orderNo).then(res => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.orderProductList = res.data
            this.orderProductList.forEach(item => {
              if (item.productImage && item.productImage.length > 0) {
                var json = JSON.parse(item.productImage)
                item.productImage = define.comUrl + json[0].url
              } else {
                item.productImage = undefined
              }
            })
            this.isEdit = false
            this.isAdd = false
            this.isClickSave = true
          } else {
            GetCustomerCommodity().then(res => {
              if (res.code === 200) {
                if (res.data && res.data.length > 0) {
                  this.productList = res.data
                  this.productList.forEach(item => {
                    if (item.productImage && item.productImage.length > 0) {
                      var json = JSON.parse(item.productImage)
                      item.productImage = define.comUrl + json[0].url
                    } else {
                      item.productImage = undefined
                    }
                  })
                  this.productList.forEach(item => {
                    this.$set(item, 'isActive', false)
                  })
                  this.isEdit = true
                  this.isAdd = false
                  this.isClickSave = false
                }
              }
            })
          }
        }
      })
    },
    add() {
      this.isAdd = true
      this.isEdit = false
      this.isClickSave = false
      this.$nextTick(() => {
        this.$refs.CommoditiesEdit.init()
      })
    },
    edit(item) {
      this.isAdd = true
      this.isEdit = false
      this.isClickSave = false
      this.$nextTick(() => {
        this.$refs.CommoditiesEdit.init(item.id)
      })
    },
    del(item) {
      this.$confirm('确定删除该商品信息吗?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        DeleteCustomerCommodity(item.id).then(res => {
          if (res.code === 200) {
            this.showCustomerCommodity()
          }
        })
      })
    },
    showCustomerCommodity() {
      GetCustomerCommodity().then(res => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.productList = res.data
            this.productList.forEach(item => {
              if (item.productImage && item.productImage.length > 0) {
                var json = JSON.parse(item.productImage)
                item.productImage = define.comUrl + json[0].url
              } else {
                item.productImage = undefined
              }
            })
            this.isEdit = true
            this.isAdd = false
            this.isClickSave = false
          }
        }
      })
    },
    showOrderCommodity() {
      GetOrderCommodities(this.data.orderNo).then(res => {
        if (res.code === 200) {
          this.orderProductList = res.data
          this.orderProductList.forEach(item => {
            if (item.productImage && item.productImage.length > 0) {
              var json = JSON.parse(item.productImage)
              item.productImage = define.comUrl + json[0].url
            } else {
              item.productImage = undefined
            }
          })
          this.isEdit = false
          this.isAdd = false
          this.isClickSave = true
        }
      })
    },
    confirm() {
      if (this.activeProductList.length > 0) {
        SaveOrderCommodities({
          customerCommodityIds: this.activeProductList,
          orderNo: this.data.orderNo
        }).then(res => {
          if (res.code === 200) {
            this.showOrderCommodity()
            CheckOrderComplete(this.data.orderNo).then(res => {
              if (res.code === 200 && res.data) {
                this.$emit('next', res.data)
              }
            })
          }
        })
      }
    },
    // 方法
    clickSave(id) {
      if (this.activeProductList.indexOf(id) < 0) {
        this.activeProductList.push((id))
      }
      this.showCustomerCommodity()
    },
    // 选中
    activeList(item) {
      const isOk = this.activeProductList.includes(item.id)
      if (!isOk) {
        this.productList.forEach(res => {
          if (item.id == res.id) {
            this.$set(res, 'isActive', !res.isActive)
            this.activeProductList.push(res.id)
          }
        })
      } else {
        this.$set(item, 'isActive', !item.isActive)
        const index = this.activeProductList.indexOf(item.id)
        if (index !== -1) {
          this.activeProductList.splice(index, 1)
        }
      }
    }
  }
}
</script>
<style scoped lang='scss'>
	.commodities {
		.card-one {
			width: 964px;
			height: 88px;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 16px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.card-one-l {
				text-align: left;

				.card-one-l-1 {
					font-size: 18px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					color: #333333;
				}

				.card-one-l-2 {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					margin-top: 11px;
				}
			}

			.card-one-r {
				button {
					width: 179px;
					height: 40px;

					span {
						margin-right: 8px;
					}
				}
			}
		}

		.card-two {
			width: 964px;
			height: auto;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 16px;
			margin-top: 16px;
			display: flex;
			align-items: center;
			//justify-content: center;
			align-content: flex-start;
			flex-wrap: wrap;

			.card-two-item-active {
				background: #FFFCFA !important;
				border: 1px solid #E95506 !important;
				border-radius: 0px !important;
				box-sizing: border-box;

				.active-img {
					position: relative;
					left: -120px;
					top: -118px;
				}
			}

			.card-two-item {
				//margin-bottom: 24px;
				width: 50%;
				height: 168px;
				background: #FFFFFF;
				border-radius: 8px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				&:hover {
					background: #FFFCFA;
					border: 0px solid #E95506;
				}

				.card-content {
					flex: 1;
					text-align: left;
					margin-left: 16px;

					p {
						font-size: 17px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #333333;
					}

					div {
						height: 28px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 20px;
					}
				}

				.card-button {
					width: 168px;
					align-self: flex-start;
					margin-top: 24px;

					span {
						font-size: 16px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #E90606;
						cursor: pointer;
						margin-right: 16px;
					}

					button {
						width: 64px;
						height: 32px;
						cursor: pointer;
					}
				}
			}

			.foot-buttom {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;
				margin: 24px 0;
				padding: 0 16px;

				span {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #E90606;
					cursor: pointer;
				}

				button {
					width: 200px;
					height: 40px;
				}
			}
		}

		.card-third {
			width: 964px;
			height: auto;
			background: #FFFFFF;
			border-radius: 8px;
			padding: 0 16px;
			margin-top: 16px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex-wrap: wrap;

			.card-third-item {
				//margin-bottom: 24px;
				width: 50%;
				height: 168px;
				background: #FFFFFF;
				border-radius: 8px;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.card-content {
					flex: 1;
					text-align: left;
					margin-left: 16px;

					p {
						font-size: 17px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						color: #333333;
					}

					div {
						height: 28px;
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						color: #333333;
						line-height: 20px;
					}
				}
			}

			.foot-buttom {
				display: flex;
				align-items: center;
				justify-content: end;
				width: 100%;
				margin-bottom: 24px;

				button {
					width: 200px;
					height: 40px;
				}
			}
		}
	}

	.invoice-mian {
		width: 964px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		padding: 0 16px;
	}
</style>
